<template>
  <div class="time-component">
    <div class="interval-time-container" :class="{ readonly }">
      <div
        class="format-time-text"
        :style="{ background: maskColor }"
        @click="click"
      >
        <div v-show="value">
          {{ timeFormat }}
          <i
            v-if="clearAble"
            @click.stop="clear()"
            class="el-icon-error del-icon"
          ></i>
        </div>
        <div v-show="!value" class="placeholder">None</div>
      </div>
      <el-time-picker
        ref="timePicker"
        align="right"
        style="width: 100px !important"
        :picker-options="{ selectableRange, format: 'HH:mm' }"
        v-model="value"
        :default-value="defaultTime"
        value-format="HH:mm"
        @focus="$emit('focus')"
        placeholder="None"
      >
      </el-time-picker>
    </div>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../../assets/style/theme.less";

.time-component {
  .interval-time-container {
    position: relative;
    height: 30px;
    cursor: pointer;
    &.readonly {
      opacity: 0.3;
    }
    .placeholder {
      color: #cbced5;
    }
    .format-time-text {
      position: absolute;
      right: 0;
      z-index: 9;
      display: flex;
      align-items: center;
      height: 30px;
      top: 0;
      width: 100%;
      justify-content: flex-end;
      .del-icon {
        font-size: 13px;
        margin-left: 8px;
        position: relative;
        top: 1px;
        cursor: pointer;
        &:active,
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
<script>
import moment from "moment-timezone";

export default {
  name: "TimeComponent",
  model: {
    // 实现v-model
    prop: "val",
    event: "updateVal",
  },
  props: {
    maskColor: { type: String, default: "#FFF" },
    prefix: {
      type: String, // 前缀
      default: "",
    },
    clearAble: {
      type: Boolean, // 是否允许清空
      default: true,
    },
    val: {
      required: true,
    },
    selectableRange: {
      type: String, // 文本值
      required: true,
    },
    readonly: {
      // 是否只读
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultTime() {
      return moment("10", "m").toDate();
    },
    /**
     * 格式化时间
     */
    timeFormat() {
      const interval = moment(this.value, "HH:mm");
      let str = "";
      if (this.prefix) {
        str += `${this.prefix} `;
      }
      if (interval.hours() > 0) {
        str += `${interval.hours()} hour`;
        if (interval.hours() > 1) {
          str += "s";
        }
      }
      if (interval.minutes() > 0) {
        if (str) {
          str += " ";
        }
        str += `${interval.minutes()} minute`;
        if (interval.minutes() > 1) {
          str += "s";
        }
      }
      return str;
    },
  },
  data() {
    return {
      value: this.val,
    };
  },
  methods: {
    click() {
      if (!this.readonly) {
        this.$refs.timePicker.focus();
      }
      this.$emit("itemClick");
    },
    /**
     *  清空时间
     */
    clear() {
      this.value = "";
    },
  },
  watch: {
    /**
     * 监听文本值变化，变化时触发updateVal事件，实现双向绑定
     */
    value() {
      this.$emit("updateVal", this.value);
    },
    /**
     * 当props val变化时改变data中value值，从而实现双向绑定
     */
    val(val) {
      this.value = val;
    },
  },
};
</script>
